import FooterControl from '@/components/FooterControl.vue';
import { pageSizes, pickerOptions } from '@/config/constant';
import pageSize from '@/mixins/memoryPageSize';

export default {
  name: 'sale-drug',
  components: { FooterControl },
  mixins: [ pageSize ],
  data() {
    return {
      tagType: 1, // 标签类型
      labelDialogTitle: '自动标签申请',
      labelDialog: false,
      pageSizess: pageSizes,
      total: 0, // 数据总条数
      hospitalId: '',
      ruleForm: {
        tagName: '',
        tagRule: '',
      },
      rules: {
        tagName: [
          { required: true, message: '请填写标签名', trigger: 'blur' }
        ],
        tagRule: [
          { required: true, message: '请填写理由', trigger: 'blur' }
        ],
      },
      isLoading: false,
      tags: [], // 标签列表
      tagsList: [],//标签分页信息
      query: {
        pageSize: 20, // 每页数据条数
        currentPage: 1, // 页码 从1开始
      },
    };
  },

  methods: {
    // 获取标签信息
    getTag() {
      this.$api.member.tag().then((res) => {
        this.tags = res.hosPitalTag;
      });
    },
    // 获取标签分页信息
    getTabsList() {
      this.$api.member.tag(this.query).then((res) => {
        console.log(1111, res);
        this.tagsList = res.hosPitalTag || [];
        this.total = res.totalSize || 0;
      })
    },
    // 打开提交标签弹框
    openTagBox(type) {
      this.tagType = type;
      if (type === 0) {
        this.labelDialogTitle = '自动标签申请';
      } else {
        this.labelDialogTitle = '手动标签申请';
      }
      this.labelDialog = true;
    },
    // 提交标签
    submitTag() {
      console.log('测试申请');
      this.$api.member.applyTag({
        ...this.ruleForm,
        tagType : this.tagType
      }).then(() => {
        this.$message({
          type: 'success',
          message: '申请标签成功!',
        });
        this.ruleForm.tagName = '';
        this.ruleForm.tagRule = '';
        this.labelDialog = false;
        this.getTag();
        this.getTabsList();
      }).catch(() => {
      });
    },
    // 检查标签表单
    checkTagForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitTag();
        } else {
          return false;
        }
      });
    },
    // 每页展示数据条数变更
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.getTabsList();
    },
    // 翻页
    handleCurrentChange(value) {
      this.page = value;
      this.getTabsList();
    },
  },
  filters: {
    // 过滤标签类型 0:自动 1:手动
    getTagType(status) {
      const statuss = Number(status);
      return statuss === 0 ? '自动' : '手动';
    },
  },
  mounted() {
    this.getTag();
    this.getTabsList();
  },
};
